import { Helper } from '../Helper';
export class ArrCloneHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'UNPACK');
        sb.emitOp(node, 'PACK');
    }
}

//# sourceMappingURL=ArrCloneHelper.js.map
